import {EditOutlined, ReadOutlined, SettingOutlined} from '@ant-design/icons';
import {TagProps} from 'antd/es/tag';
import {AuthorizedUserAccessLevel} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import React from 'react';

interface Props extends TagProps {
  accessLevel: AuthorizedUserAccessLevel;
}

export const AccessLevelTag: React.FC<Props> = ({accessLevel, ...props}) => {
  switch (accessLevel) {
    case AuthorizedUserAccessLevel.ADMIN_ACCESS:
      return (
        <StatusTag {...props} color={colors.grey}>
          Admin <SettingOutlined/>
        </StatusTag>
      );
    case AuthorizedUserAccessLevel.WRITE_ACCESS:
      return (
        <StatusTag {...props} color={colors.grey}>
          Write <EditOutlined/>
        </StatusTag>
      );
    case AuthorizedUserAccessLevel.READ_ACCESS:
      return (
        <StatusTag {...props} color={colors.grey}>
          Read <ReadOutlined/>
        </StatusTag>
      );
  }

  return null;
};
